import CloseIcon from '@mui/icons-material/Close';
import WavingHandIcon from '@mui/icons-material/WavingHand';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  Typography,
  useTheme,
} from '@mui/material';
import Draggable from 'react-draggable';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import RatesTable from './ratesTable';
import WsCurrency from '@/modules/dashboard/currency/WsCurrency';
import { RatesPopUpProps } from '../types';
import getStyles from './promoterRates.style';

const RatesPopUp = ({
  isOpen,
  position,
  updatePosition,
  setIsOpen,
}: RatesPopUpProps) => {
  const { t } = useTranslation();
  const location = useLocation();

  const theme = useTheme();
  const styles = getStyles(theme);

  const renderRates = () => {
    if (location.pathname === '/dashboard') {
      return <RatesTable />;
    }
    return (
      <WsCurrency>
        <RatesTable />
      </WsCurrency>
    );
  };

  if (!isOpen) return null;

  return createPortal(
    <Box className={styles.ratesPopUp}>
      <Draggable
        onStop={(_, data) => updatePosition({ x: data.x, y: data.y })}
        position={position}
      >
        <Card className={styles.ratesPopUpCard}>
          <CardHeader
            className={styles.ratesPopUpHeader}
            title={
              <Typography variant="subtitle1">
                {t('prtActionButton')}
              </Typography>
            }
            action={
              <IconButton
                className={styles.ratesPopUpHeaderAction}
                size="small"
                onClick={() => setIsOpen(false)}
              >
                <CloseIcon />
              </IconButton>
            }
          />
          <CardContent>
            <Box className={styles.ratesPopUpContent}>
              <WavingHandIcon sx={{ fontSize: 16 }} />
              <Typography variant="caption">
                {t('prtActionButtonDescription')}
              </Typography>
            </Box>
            {renderRates()}
          </CardContent>
        </Card>
      </Draggable>
    </Box>,
    document.body
  );
};

export default RatesPopUp;
